;(function () {
	'use strict';

	if (!customElements.get('slideshow-banner')) {
		class SlideshowBanner extends HTMLElement {
			constructor() {
				super();
				this.swiper = null;
			}

			connectedCallback() {
				this.initSwiper();
				window.addEventListener('resize', () => this.initSwiper.call(this));
			}
		}

		SlideshowBanner.prototype.initSwiper = function() {
			const { autoplay, delay, pauseOnMouseEnter, loop, speed } = this.dataset;
			console.log("🚀 ~ speed:", speed)
			console.log("🚀 ~ loop:", loop)
			console.log("🚀 ~ pauseOnMouseEnter:", pauseOnMouseEnter)
			console.log("🚀 ~ dataset:", this.dataset)
			console.log("🚀 ~ delay:", delay)
			console.log("🚀 ~ autoplay:", autoplay)
			
			const sliderPauseOnMouseEnter = pauseOnMouseEnter == 'true' ? true : false;
			const sliderAutoplay = autoplay == 'true' ? {
				delay: +delay,
				disableOnInteraction: false,
				pauseOnMouseEnter: sliderPauseOnMouseEnter
			} : false;

			this.swiper = new Swiper(this, {
				lazy: true,
				keyboard: {
					enabled: true,
				},
				pagination: {
					el: '.swiper-pagination', 
					clickable: true
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				autoplay: sliderAutoplay,
				loop: loop == 'true' ? true : false,
				speed: +speed
			});
		};

		customElements.define('slideshow-banner', SlideshowBanner);
	}
})()
